import { TokenParseModel } from './tokenParseModel';
import { isFunction, isObject, isString, isArray, getSafeRandom } from './utils';
import ajax from './ajax';
import { getFxExpression } from './getFxExpression';
import ViewModel from './viewmodel';
const logicTokenType = new Set(['=', '≠', '>', '≥', '<', '≤', '⊂', '⊄', '⊇', '⊆']);
const dateType = new Set(['datepicker', 'datetimepicker', 'timepicker', 'rangepicker', 'datePickerNoTimeZone', 'NCTZDatePickerStart', 'NCTZDatePickerRangeDay', 'NCTZDatePickClientHourTime', 'NCTZDatePickClientTime', 'NCTZDatePickerEnd']);
const dateSpecialType = new Set(['datetimepicker', 'NCTZDatePickClientTime']);

// 字段控制规则
export function handleTemplateRule(afterData) {
    let {
        type = 'table',
        areaCode,
        formId,
        key,
        value,
        index,
        record,
        callback, // 回调方法
        runTemplateRuleFun,
        rows = [], // 复制粘贴，批改传进来的是rows
        mode = 'line', // 单元格编辑：line 侧拉编辑：model 下拉编辑：expand
        triggerMode = 'afterEdit', // 触发模式，默认值 'afterEdit' 编辑后, 'init' 领域初始化以后调用，'afterFormula' 显示公式之后调用
        ruleData, // 显示公式用返回的数据，编辑后从页面取数据
    } = afterData;
    let meta = this.meta.getMeta();
    console.log(meta);
    // 兼容表格侧拉编辑后
    let newAreaCode = formId || areaCode;
    if (!newAreaCode) {
        console.warn('字段控制规则缺少触发区域');
        return;
    }
    let templetRuleArr = meta[`${newAreaCode}.${key}`] || [];
    if (!templetRuleArr.length) {
        // this.handleRuleSetValue = false;
        // 如果没有字段控制规则，直接走领域编辑后
        isFunction(callback) && callback(this);
        return;
    }
    // 最后执行的 回调方法
    let newCallBack = null;
    // 遍历当前字段的规则组
    for (let ruleIndex = 0; ruleIndex < templetRuleArr.length; ruleIndex++) {
        const ruleElement = templetRuleArr[ruleIndex];
        // 判断是否满足当前规则的前置条件
        // 复制粘贴、批改会传进来rows，前置条件不再取表格数据，直接拿rows
        let { valueResult, ruleAreaType, ruleAreaCode, ruleItemCode, conditionResult } = getCheckTemplateData.call(this, { areaCode: newAreaCode, key, index, meta, rulecondition: ruleElement.rulecondition, rows: rows.length ? rows : null, ruleData, triggerMode });
        // 获取字段控制规则结果的所有组件类型和编码
        let { ruleResultType, ruleResultCode } = getRuleResultType({ controlresult: ruleElement.controlresult, meta });
        
        // 如果有前置条件
        let tableData = {};
        if (conditionResult.length) {
            let tokenModel = new TokenParseModel(conditionResult);
            tokenModel.initNodeTreeData();
            // 主动触发字段控制规则，并且是表格，但是表格没有数据
            if (triggerMode === 'init' && type === 'table' && !rows.length) {
                tableData = null;
                continue;
            } else if (type === 'form' && ruleAreaType.has('table') || rows.length) {
                // 触发字段是表单，前置条件有表格，控制结果对表格逐行处理
                // 复制粘贴、批改会传进来rows，前置条件不再取表格数据，直接拿rows，需要逐行处理
                let resultTableData = [];
                let resultTableCode = '';
                for (const key in valueResult) {
                    if (Object.hasOwnProperty.call(valueResult, key)) {
                        const valueResultElement = valueResult[key];
                        // 找到 valueResult 中 key 值在 ruleAreaCode 里，value值为数组的项
                        // 这里拿到的是全表数据，需要根据每一行的值走前置条件的判断
                        if (ruleAreaCode.has(key) && isArray(valueResultElement)) {
                            for (let tableIndex = 0; tableIndex < valueResultElement.length; tableIndex++) {
                                // 找到具体一行的数据，根据 ruleItemCode 取到当前行的具体字段的值，重新组成 resultValue
                                const tableRowData = valueResultElement[tableIndex];
                                let newValueResult = {};
                                let ruleItemCodeArr = [...ruleItemCode];
                                for (let itemIndex = 0; itemIndex < ruleItemCodeArr.length; itemIndex++) {
                                    const tableItemCode = ruleItemCodeArr[itemIndex];
                                    newValueResult = { ...valueResult, [key]: { [tableItemCode]: tableRowData.values[tableItemCode]?.value } };
                                }
                                // 按照当前行的值走前置条件，满足所有前置条件返回true 
                                let flag = tokenModel.executeAst(newValueResult, tokenModel.nodeTree)?.tValue;
                                // 把表格中所有满足条件的行拿出来，一起交给后端走设值逻辑
                                // console.log("🚀 ~ file: createPage.js ~ line 2098 ~ Page ~ constructor ~ flag", flag);
                                if (flag) {
                                    resultTableCode = key;
                                    resultTableData.push(tableRowData);
                                }
                            }
                        }
                    }
                }
                if (resultTableData.length) {
                    if (rows.length) {
                        tableData[areaCode] = resultTableData;
                    } else {
                        tableData[resultTableCode] = resultTableData;
                    }
                } else {
                    ruleIndex === templetRuleArr.length - 1 && (newCallBack = callback);
                    continue;
                }
            } else if (type === 'form' && !ruleAreaType.has('table') && ruleResultType.has('table')) {
                // 触发字段是表单，前置条件是表单，控制结果是表格，控制结果对表格逐行处理
                let flag = tokenModel.executeAst(valueResult, tokenModel.nodeTree)?.tValue;
                // console.log("🚀 ~ file: createPage.js ~ line 2113 ~ Page ~ constructor ~ flag", flag);
                if (flag) {
                    let ruleResultCodeArr = [...ruleResultCode];
                    for (let ruleResultIndex = 0; ruleResultIndex < ruleResultCodeArr.length; ruleResultIndex++) {
                        let resultTableData = [];
                        let ruleResultTableCode = ruleResultCodeArr[ruleResultIndex];
                        if (this.tableDataSource[ruleResultTableCode]) {
                            resultTableData = this.table.getAllTableData(ruleResultTableCode).rows;
                        } else if (this.editTableDataSource[ruleResultTableCode]) {
                            resultTableData = this.editTable.getVisibleRows(ruleResultTableCode);
                        } else if (this.cardTableDataSource[ruleResultTableCode]) {
                            resultTableData = this.cardTable.getVisibleRows(ruleResultTableCode);
                        } else {
                            continue;
                        }
                        tableData[ruleResultTableCode] = resultTableData;
                    }
                } else {
                    ruleIndex === templetRuleArr.length - 1 && (newCallBack = callback);
                    continue;
                }
            } else {
                // 其他情况下表格取值按照当前行数据取值
                let flag = tokenModel.executeAst(valueResult, tokenModel.nodeTree)?.tValue;
                // console.log("🚀 ~ file: createPage.js ~ line 2132 ~ Page ~ constructor ~ flag", flag);
                if (flag) {
                    tableData = null;
                } else {
                    ruleIndex === templetRuleArr.length - 1 && (newCallBack = callback);
                    continue;
                }
            }
        } else {
            // 触发字段是表单，前置条件空，控制结果是表格，控制结果对表格逐行处理
            if (type === 'form' && ruleResultType.has('table')) {
                let ruleResultCodeArr = [...ruleResultCode];
                for (let ruleResultIndex = 0; ruleResultIndex < ruleResultCodeArr.length; ruleResultIndex++) {
                    let resultTableData = [];
                    let ruleResultTableCode = ruleResultCodeArr[ruleResultIndex];
                    if (this.tableDataSource[ruleResultTableCode]) {
                        resultTableData = this.table.getAllTableData(ruleResultTableCode).rows;
                    } else if (this.editTableDataSource[ruleResultTableCode]) {
                        resultTableData = this.editTable.getVisibleRows(ruleResultTableCode);
                    } else if (this.cardTableDataSource[ruleResultTableCode]) {
                        resultTableData = this.cardTable.getVisibleRows(ruleResultTableCode);
                    }
                    tableData[ruleResultTableCode] = resultTableData;
                }
            } else if (rows.length && !conditionResult.length) {
                // 只有复制粘贴、批改这两种情况，会传进来rows，如果前置条件不存在，valueResult直接拿rows
                tableData = valueResult;
            } else {
                tableData = null;
            }
        }
        runTemplateRule.call(this, { currentAreaCode: areaCode, currentFormCode: formId, meta, controlresult: ruleElement.controlresult, afterData, record: tableData ? tableData : (record ? { [areaCode]: record } : null), runTemplateRuleFun, mode, callback: ruleIndex === templetRuleArr.length - 1 ? callback : null });
    }
    // 所有的字段控制规则都不满足，最后执行callback
    // 有三条规则，前两条满足，最后一条不满足，需要在这里执行callback
    // 前置条件是空，所有的控制结果都会执行，不会走到这个逻辑
    isFunction(newCallBack) && newCallBack.call(this);
}

// 获取字段控制规则校验的数据
function getCheckTemplateData(checkData) {
    // 复制粘贴、批改这两种情况，会传进来rows，前置条件不再取表格数据，直接拿rows
    let { areaCode, key, meta, index: rowIndex, rulecondition, rows, ruleData, triggerMode } = checkData;
    let conditionResult = [];
    let valueResult = {};
    // 需要逐行校验的区域和字段
    let ruleAreaType = new Set();
    let ruleAreaCode = new Set();
    let ruleItemCode = new Set();
    if (rulecondition.length) {
        try {
            let { condition } = rulecondition[0];
            conditionResult = JSON.parse(condition);
        } catch (error) {
            conditionResult = [];
        }

        for (let index = 0; index < conditionResult.length; index++) {
            const element = conditionResult[index];
            // 根据 type 类型取前置条件中需要用到的字段
            let { areaCode, itemCode, itemType } = element;
            if (element.type === 'field') {
                element.text = itemCode ? `${areaCode}.${itemCode}` : `${areaCode}`;
                valueResult[areaCode] = valueResult[areaCode] || {};
                // 获取组件类型
                let type = meta[areaCode]?.moduletype;
                // 收集所有前置条件的组件类型 这里不需要区分是哪种表格
                ruleAreaType.add(type);
                let tableType = 'simpleTable';
                if (this.tableDataSource[areaCode]) {
                    tableType = 'simpleTable';
                } else if (this.editTableDataSource[areaCode]) {
                    tableType = 'editTable';
                } else if (this.cardTableDataSource[areaCode]) {
                    tableType = 'cardTable';
                }
                if (type !== 'table') {
                    // 查询区，表单取字段值，传rowIndex取表格当前行数据
                    valueResult[areaCode] = { ...valueResult[areaCode], [itemCode]: getCheckTemplateValue.call(this, { ...element, type, ruleData, triggerMode }) };
                } else {
                    ruleAreaCode.add(areaCode);
                    ruleItemCode.add(itemCode);
                    if (rows) {
                        // 复制粘贴、批改这两种情况，会传进来rows，前置条件不再取表格数据，直接拿rows
                        valueResult[areaCode] = { ...valueResult[areaCode], [itemCode]: rows };
                    } else if (rowIndex > -1) {
                        // 单行数据
                        valueResult[areaCode] = { ...valueResult[areaCode], [itemCode]: getCheckTemplateValue.call(this, { ...element, type: tableType, rowIndex, ruleData, triggerMode }) };
                    } else {
                        valueResult[areaCode] = getCheckTemplateValue.call(this, { ...element, type: tableType, rowIndex, ruleData, triggerMode });
                    }
                }
                // 当前字段是参照，下一个字段是逻辑关系符，再下一个字段是常量，常量返回的是{refpk:'111',refcode:'222',refname:'333'}

                if (itemType === 'refer' && logicTokenType.has(conditionResult[index + 1]?.type) && conditionResult[index + 2]?.type === 'index' && (typeof conditionResult[index + 2]?.tokenValue !== 'string')) {
                    let fieldValued = meta[areaCode]?.items.find(item => item.attrcode === itemCode)?.fieldValued || 'refpk';
                    // 如果参照是设置的fx函数
                    if(conditionResult[index + 2].tokenValue.refpk.includes('#')){
                        // refname: "用户主职部门" refpk: "#rbacdept#" 
                        // 需要把 refpk 字段换成 value 调用 getFxExpression 方法得到翻译后的结果，根据返回值赋值给 refpk
                        let newContext = { ...ViewModel.getContext(), ...this.app_context };
                        let fxValue = getFxExpression({ value: conditionResult[index + 2].tokenValue.refpk }, newContext);
                        let referValue = { ...conditionResult[index + 2].tokenValue, refpk: fxValue.value };
                        conditionResult[index + 2].tokenValue = referValue[fieldValued];
                    }else{
                        conditionResult[index + 2].tokenValue = conditionResult[index + 2].tokenValue[fieldValued];
                    }
                }

                // 当前字段是日期类型，为了和前置条件保持一致，除了带时分秒的，正常只取年月日
                if (dateType.has(itemType) && !dateSpecialType.has(itemType)) {
                    if (isArray(valueResult[areaCode][itemCode])) {
                        valueResult[areaCode][itemCode].forEach(item => {
                            item.values[itemCode].value = item.values[itemCode].values.slice(0, 10);
                        });
                    } else if (isString(valueResult[areaCode][itemCode])) {
                        valueResult[areaCode][itemCode] = valueResult[areaCode][itemCode].slice(0, 10);
                    }
                }
            }
        }
        // 只有复制粘贴、批改这两种情况，会传进来rows，如果前置条件不存在，valueResult直接拿rows
        if (rows) {
            valueResult[areaCode] = rows;
        }
    }
    return { valueResult, ruleAreaType, ruleAreaCode, ruleItemCode, conditionResult };
}

// 获取字段控制规则结果的所有组件类型
function getRuleResultType(ruleData) {
    let { controlresult, meta } = ruleData;
    let ruleResultType = new Set();
    let ruleResultCode = new Set();
    for (let index = 0; index < controlresult.length; index++) {
        const element = controlresult[index];
        if (element.targettype === 'field') {
            let areaCode = element.targetvalue.split('.')[0];
            let type = meta[areaCode]?.moduletype;
            ruleResultType.add(type);
            ruleResultCode.add(areaCode);
        }
    }
    return { ruleResultType, ruleResultCode };
}

// 字段控制规则取值
function getCheckTemplateValue(itemspecs = {}) {
    let { areaCode, itemCode, type, rowIndex = -1, ruleData, triggerMode } = itemspecs;
    let { billtype } = this.billinfo || {};
    let value;
    switch (type) {
        case 'form':
            // console.log("🚀 ~ file: createPage.js ~ line 2227 ~ Page ~ this.getCheckTemplateValue ~ this.form.getFormItemsValue(areaCode, itemCode)", this.form.getFormItemsValue(areaCode, itemCode));

            if (triggerMode === 'afterFormula') {
                if (billtype === 'form' && ruleData?.model?.rows?.[0]) {
                    value = ruleData.model.rows[0].values[itemCode]?.value;
                } else if ((billtype === 'card' || billtype === 'extcard') && ruleData?.head?.[areaCode]?.rows?.[0]) {
                    value = ruleData.head[areaCode].rows[0].values[itemCode]?.value;
                }
            } else {
                value = this.form.getFormItemsValue(areaCode, itemCode)?.value;
            }
            break;
        case 'simpleTable':

            if (triggerMode === 'afterFormula') {
                if (billtype === 'grid' && ruleData?.model?.rows) {
                    value = (ruleData.model.rows || []).map(item => {
                        item.rowId = item.rowId || String(new Date().getTime()).slice(-5) + getSafeRandom().toString(12);
                        return item;
                    });
                }
            } else {
                value = this.table.getAllTableData(areaCode).rows;
            }
            break;
        case 'editTable':

            if (triggerMode === 'afterFormula') {
                if (billtype === 'grid' && ruleData?.model?.rows) {
                    value = ruleData.model.rows;
                } else if (billtype === 'card' && ruleData?.body?.[areaCode]?.rows) {
                    value = ruleData.body[areaCode].rows;
                } else if (billtype === 'extcard' && ruleData?.bodys?.[areaCode]?.rows) {
                    value = ruleData.bodys[areaCode].rows;
                }
                value = (value || []).map(item => {
                    item.rowId = item.rowId || String(new Date().getTime()).slice(-5) + getSafeRandom().toString(12);
                    return item;
                });
            } else {
                value = this.editTable.getVisibleRows(areaCode);
            }
            break;
        case 'cardTable':

            if (triggerMode === 'afterFormula') {
                if (billtype === 'grid' && ruleData?.model?.rows) {
                    value = ruleData.model.rows;
                } else if (billtype === 'card' && ruleData?.body?.[areaCode]?.rows) {
                    value = ruleData.body[areaCode].rows;
                } else if (billtype === 'extcard' && ruleData?.bodys?.[areaCode]?.rows) {
                    value = ruleData.bodys[areaCode].rows;
                }
                value = (value || []).map(item => {
                    item.rowId = item.rowId || String(new Date().getTime()).slice(-5) + getSafeRandom().toString(12);
                    return item;
                });
            } else {
                value = this.cardTable.getVisibleRows(areaCode);
            }
            break;
        case 'search':
            value = this.search.getSearchValByField(areaCode, itemCode);
            break;
        default:
            break;
    }
    // 如果传入rowIndex 取表格当前行的数据
    value = rowIndex > -1 ? value[rowIndex].values[itemCode]?.value : value;
    return value;
}

// 执行字段控制结果
// TODO 编辑表格当前行，控制当前行单元格的编辑性
function runTemplateRule(controlresultObj = {}) {
    let { currentAreaCode, currentFormCode, meta, controlresult, afterData, runTemplateRuleFun, record, mode, callback, triggerMode } = controlresultObj;
    let setValueArray = [];
    let gridRelationMap = getGridRelationMap(meta);
    for (let index = 0; index < controlresult.length; index++) {
        const item = controlresult[index];
        // TODO 控制基础组件 只有可见性
        if (item.targettype === 'comp') {
            runTemplateRuleFun && runTemplateRuleFun(item);
            // pageModel.component.setAttributes({ [moduleId]: { visible: item.paramvalue } });
        } else {
            // 获取组件类型
            // 拿到的可能是 childform2.pk_material.materialspec 这样的
            let dotIndex = item.targetvalue.indexOf('.');
            let areaCode = item.targetvalue.slice(0, dotIndex);
            let itemCode = item.targetvalue.slice(dotIndex + 1);
            // let [areaCode, itemCode] = item.targetvalue.split('.');
            let type = meta[areaCode]?.moduletype;
            if (item.action === 'setvalue') {
                setValueArray.push({ ...item, currentAreaCode, areaCode, itemCode, type });
            } else {
                // 修改模板属性
                if (this.tableDataSource[areaCode]) {
                    type = 'simpleTable';
                } else if (this.editTableDataSource[areaCode]) {
                    type = 'editTable';
                } else if (this.cardTableDataSource[areaCode]) {
                    type = 'cardTable';
                }
                modifyMetaHandler.call(this, { ...item, currentAreaCode, currentFormCode, areaCode, itemCode, type, record, mode, gridRelationMap, meta, triggerMode });
            }
        }
        // 执行最后一条控制规则之后 走领域编辑后
        index === controlresult.length - 1 && isFunction(callback) && callback.call(this);
    }
    // 控制规则设值
    if (setValueArray.length) {
        this.handleRuleSetValue = true;
        handleAfterEdit.call(this, { ...afterData, controlresult: setValueArray, record });
    }
}

// 控制规则修改模板信息
function modifyMetaHandler(item = {}) {
    // action控制行为字段值为颜色时，paramvalue字段值为色值
    // action控制行为字段值为可见性时，paramvalue字段值为：可见(visible)、不可见(invisible)
    // action控制行为字段值为必输性时，paramvalue字段值为：必输(required)、非必输(unrequired)
    // action控制行为字段值为可编辑性时，paramvalue字段值为：可编辑(editable)、不可编辑(uneditable)
    let { currentAreaCode, currentFormCode, action, paramvalue, areaCode, itemCode, type, record, mode, gridRelationMap, meta, triggerMode } = item;
    let attribute = action.replace('set', '');
    // { [itemCode]: { visible: false } }
    // { [itemCode]: { rulecolor: { label : 'red' } } }
    // 可编辑性字段转换
    if (action === "seteditable") {
        attribute = 'disabled';
        paramvalue = paramvalue === 'editable' ? 'enabled' : 'disabled';
    }
    let ruleColorValue = {};
    if (action === "settitlecolor") {
        attribute = 'rulecolor';
        ruleColorValue = { color: paramvalue };
    } else if (action === "setcontentcolor") {
        attribute = 'rulecolor';
        ruleColorValue = { contentcolor: paramvalue };
    }
    switch (type) {
        case 'form':
            let formValue = attribute === 'rulecolor' ? ruleColorValue : attribute === paramvalue;
            if (meta?.corerelation) {
                // 关键信息区 逻辑处理  可见性，标题颜色，内容颜色
                let mainFormId = areaCode;
                for (const key in meta.corerelation) {
                    if (Object.hasOwnProperty.call(meta.corerelation, key)) {
                        const element = meta.corerelation[key];
                        element?.includes(areaCode) && meta[key]?.moduletype === 'form' && (mainFormId = key);
                    }
                }
                if (attribute === 'rulecolor') {
                    Object.keys(formValue).forEach(item => {
                        this.form.setFormCardItemAttribute(mainFormId, areaCode, itemCode, item, formValue[item]);
                    });
                } else {
                    this.form.setFormCardItemAttribute(mainFormId, areaCode, itemCode, attribute, formValue);
                }
                if (mainFormId !== areaCode) {
                    return;
                }
            }
            if (attribute === 'rulecolor') {
                Object.keys(formValue).forEach(item => {
                    this.form.setFormItemsAttribute(areaCode, itemCode, item, formValue[item]);
                });
            } else {
                // 从表格的展开和下拉区域的关联关系里找一下 当前表单是不是cardtable关联的区域
                if (gridRelationMap[areaCode]) {
                    currentFormCode = areaCode;
                }
                if (currentAreaCode && (currentFormCode || mode === 'model' || mode === 'expand') && record && record[currentAreaCode]) {
                    // 侧拉编辑：model 下拉编辑：expand
                    // areaCode 和 formId 都存在，说明是 cardTable 的侧拉触发的编辑后事件，这里需要调用表格的 API 更新数据 
                    if (isArray(record[currentAreaCode])) {
                        record[currentAreaCode].forEach(item => {
                            this.cardTable.setCellProps(currentAreaCode, item.key || item.rowid || item.rowId, itemCode, { [attribute]: attribute === paramvalue });
                        });
                    } else if (isObject(record[currentAreaCode])) {
                        this.cardTable.setCellProps(currentAreaCode, record[currentAreaCode].key || record[currentAreaCode].rowid || record[currentAreaCode].rowId, itemCode, { [attribute]: attribute === paramvalue });
                    }
                } else {
                    this.form.setFormItemsAttribute(areaCode, itemCode, attribute, formValue);
                }
            }
            break;
        case 'simpleTable':
        case 'editTable':
        case 'cardTable':
            let setTableValue = { [itemCode]: attribute === 'rulecolor' ? ruleColorValue : { [attribute]: attribute === paramvalue } };
            let table = type === 'simpleTable' ? this.table : type === 'editTable' ? this.editTable : this.cardTable;
            if (record) {
                let [tableAreaCode, tableAreaData] = Object.entries(record)[0];
                tableAreaData = Array.isArray(tableAreaData) ? tableAreaData : [tableAreaData];
                if (attribute === 'rulecolor') {
                    // 颜色逐行处理
                    if (action === "setcontentcolor") {
                        tableAreaData.forEach(item => {
                            table.setCellProps(tableAreaCode, item.key || item.rowid || item.rowId, itemCode, { style: { color: paramvalue } });
                        });
                    }
                    // 如果是修改 label 颜色还是得去调API
                    if (action === "settitlecolor") {
                        table.setColumn(areaCode, setTableValue, true);
                    }
                } else if (attribute === 'disabled') {
                    // 禁用逐行处理
                    tableAreaData.forEach(item => {
                        table.setCellProps(tableAreaCode, item.key || item.rowid || item.rowId, itemCode, { disabled: 'disabled' === paramvalue });
                    });
                } else {
                    // 可见，必输按列处理
                    table.setColumn(areaCode, setTableValue, true);
                }
            } else if (triggerMode === 'afterFormula') {
                // 没有传表格数据，控制表格属性，只有可见，必输两个 按列处理
                table.setColumn(areaCode, setTableValue, true);
            }
            // if(attribute === 'rulecolor' || attribute === 'disabled'){
            //     rowkeys.forEach(rowKey=>{
            //         this.table.setCellProps(areaCode, rowKey, itemCode, props)
            //     })
            // }else{
            //     this.table.setColumn(areaCode, simpleTableValue, true);
            // }
            break;
        // case 'editTable':
        //     let editTableValue = { [itemCode]: attribute === 'rulecolor' ? ruleColorValue : { [attribute]: attribute === paramvalue } };
        //     this.editTable.setColumn(areaCode, editTableValue, true);
        //     break;
        // case 'cardTable':
        //     let cardTableValue = { [itemCode]: attribute === 'rulecolor' ? ruleColorValue : { [attribute]: attribute === paramvalue } };
        //     this.cardTable.setColumn(areaCode, cardTableValue, true);
        //     break;
        case 'search':
            let searchValue = attribute === 'rulecolor' ? ruleColorValue : attribute === paramvalue;
            this.search.setTemlateByField(areaCode, itemCode, attribute === 'rulecolor' ? 'color' : attribute, searchValue);
            break;
        default:
            break;
    }
}

function handleAfterEdit(afterData = {}) {
    this.currentBill = JSON.parse(JSON.stringify(this.billinfo));
    let {
        type = 'table',
        areaCode,
        key,
        value,
        formMetaCode,
        record,
        changedrows,
        tableMetaCode,
        index,
        rows,
        column,
        callback,
        rowid,
        controlresult = [],
    } = afterData;
    //档案：一个节点多个卡片,多个表单、或者多个表格，判断当前是哪个界面
    if (this.billinfo instanceof Array && this.billinfo.length) {
        for (let i = 0; i < this.billinfo.length; i++) {
            if (type === 'form') {
                if (areaCode === this.billinfo[i].headcode) {
                    this.currentBill = this.billinfo[i];
                    break;
                }
            }
            if (type === 'table') {
                let billBodyCode = this.billinfo[i].bodycode;
                if (typeof billBodyCode === 'string' && areaCode === billBodyCode) {
                    this.currentBill = this.billinfo[i];
                    break;
                }
                if (billBodyCode instanceof Array && billBodyCode.includes(areaCode)) {
                    this.currentBill = this.billinfo[i];
                    break;
                }
            }
        }
    }

    let {
        billtype,
        pagecode,
        headcode,
        bodycode,
        tabletype = '',
        tabs = false,
    } = this.currentBill;

    if (!pagecode) {
        pagecode = this.getSearchParam('p');
    }
    let url, data, success;
    //单个表单 或 单个表格
    if (billtype === 'form' || billtype === 'grid') {
        if (type === 'form') {
            // 业务单元卡片页
            url = '/nccloud/platform/pub/formafteredit.do';
            data = this.createFormAfterEventData(
                pagecode,
                areaCode,
                areaCode,
                key,
                value,
                formMetaCode,
            );
        } else if (type === 'table') {
            // 币种列表页 
            url = '/nccloud/platform/pub/gridafteredit.do';
            // 单表操作 接收到的record 是当前行数据
            let newRecord = JSON.parse(JSON.stringify(record[areaCode] || {}));
            data = this.createGridAfterEventRecord(
                pagecode,
                areaCode,
                areaCode,
                key,
                changedrows,
                newRecord,
                tableMetaCode,
            );
        }
    }
    //单据
    if (billtype === 'card' || billtype === 'extcard') {
        if (Object.prototype.toString.call(bodycode) === '[object Object]') {
            let bodycodeArr = Object.keys(bodycode);
            if (bodycodeArr.length == 1) {
                bodycode = bodycodeArr[0];
            }
        }
        // 主子表 接收到的record 可能是单行数据，也可能是多行数据
        let masterChildData;
        if (billtype === 'card') {
            // 应付单管理卡片页
            // 如果是逐行处理，拿到的 record 形式为 {'card': [rows]}
            // 如果是单行触发，拿到的 record 形式为 {...row}
            let newRecord = (record && record[bodycode]) ? Array.isArray(record[bodycode]) ? record[bodycode] : [record[bodycode]] : null;
            url = '/nccloud/platform/pub/CardControlAction.do';
            masterChildData = this.createMasterChildData(pagecode, headcode, bodycode, tabletype, newRecord);
        }
        if (billtype === 'extcard') {
            // 采购订单维护卡片页 
            // 如果是逐行处理，拿到的 record 形式为 {'card': rows}
            // 如果是单行触发，拿到的 record 形式为 {...row}
            // let newRecord = record[bodycode] ? record[bodycode] : null;
            url = '/nccloud/platform/pub/ExtCardControlAction.do';
            masterChildData = this.createExtCardData(pagecode, headcode, bodycode);
            let bodyData = masterChildData.bodys;
            if (record) {
                let [tableAreaCode, tableAreaData] = Object.entries(record)[0];
                bodyData = {
                    ...masterChildData.bodys,
                    [tableAreaCode]: {
                        areaType: "table",
                        areacode: tableAreaCode,
                        rows: Array.isArray(tableAreaData) ? tableAreaData : [tableAreaData],
                    },
                };
            }
            masterChildData = { ...masterChildData, bodys: bodyData };
        }
        // let { head:{ headcode: formData }= { headcode:{} }, body:{ bodycode: tableData }={ bodycode:{} } } = masterChildData;
        data = {
            areacode: areaCode,
            attrcode: key,
            card: masterChildData,
        };
    }

    //请求成功的回调函数
    success = res => {
        let tableTypeObj = {};
        //单个表单
        if (billtype === 'form' && type === 'form') {
            if (res.data && res.data && res.data[areaCode]) {
                this.form.setAllFormValue({ [areaCode]: res.data[areaCode] }, false, false, key);
            }
        }
        //单个表格
        if (res.data && res.data && res.data[areaCode] && billtype === 'grid' && type === 'table') {
            if (tabletype && tabletype === 'cardTable') {
                //this.cardTable.setTableData(areaCode, res.data[areaCode], null, false);
                // this.cardTable.updateDataByIndexs(areaCode, [{
                //     index: index,
                //     data: res.data[areaCode].rows[index]
                // }]);
                //新增功能---差异化处理
                if (rows) {
                    // 这里要看下是不是没有rows
                    this.cardTable.updateAndAddRows({ rows: res.data[areaCode].rows, tableId: areaCode });
                } else {
                    this.cardTable.updateDataByRowId(areaCode, res.data[areaCode], false, false);
                }
                tableTypeObj[areaCode] = 'cardTable';
            } else {
                //this.editTable.setTableData(areaCode, res.data[areaCode], false);
                //新增功能---差异化处理
                this.editTable.updateDataByRowId(areaCode, res.data[areaCode], false, false);
                tableTypeObj[areaCode] = 'editTable';
            }
        }
        //单据
        if (billtype === 'card' || billtype === 'extcard') {
            //表头赋值
            if (res.data && res.data.head && res.data.head[headcode]) {
                this.form.setAllFormValue({ [headcode]: res.data.head[headcode] }, false, false, key);
            }
            let tablecode;
            if (Object.prototype.toString.call(bodycode) === '[object Object]') {
                tablecode = Object.keys(bodycode);
                if (tablecode.length == 1) {
                    tablecode = tablecode[0];
                }
            } else {
                tablecode = bodycode;
            }

            if (typeof tablecode === 'string') {
                if (res.data && res.data.body && res.data.body) {
                    if (tabletype && tabletype === 'editTable' && res.data.body[tablecode]) {
                        tableTypeObj[tablecode] = 'editTable';
                        //this.editTable.setTableData(bodycode, res.data.body[bodycode], false);
                        //新增功能---差异化处理
                        this.editTable.updateDataByRowId(
                            tablecode,
                            res.data.body[tablecode],
                            false,
                            false,
                        );
                    } else {
                        tableTypeObj[tablecode] = 'cardTable';
                        //this.cardTable.setTableData(bodycode, res.data.body[bodycode], null, false);
                        //新增功能---差异化处理
                        if (tableMetaCode && res.data.body[tableMetaCode] && !res.data.body[tablecode]) {
                            res.data.body[tablecode] = res.data.body[tableMetaCode];
                        }

                        if (rows) {
                            this.cardTable.updateAndAddRows({ rows: res.data.body[tablecode].rows, tableId: tablecode });
                        } else {
                            this.cardTable.updateDataByRowId(
                                tablecode,
                                res.data.body[tablecode],
                                false,
                                false,
                            );
                        }

                    }
                }
            } else if (tablecode instanceof Array) {
                tablecode.forEach(code => {
                    if (res.data && res.data.bodys) {
                        if (tabletype && tabletype === 'editTable' && res.data.bodys[code]) {
                            tableTypeObj[code] = 'editTable';
                            //this.editTable.setTableData(code, res.data.bodys[code], false);
                            //新增功能---差异化处理
                            this.editTable.updateDataByRowId(
                                code,
                                res.data.bodys[code],
                                false,
                                false,
                            );
                        } else {
                            tableTypeObj[code] = 'cardTable';
                            //this.cardTable.setTableData(code, res.data.bodys[code], null, false);
                            //新增功能---差异化处理
                            if (tableMetaCode && res.data.bodys[tableMetaCode] && !res.data.bodys[code]) {
                                res.data.bodys[code] = res.data.bodys[tableMetaCode];
                            }

                            if (rows && code === areaCode) {
                                this.cardTable.updateAndAddRows({ rows: res.data.bodys[code].rows, tableId: code });
                            } else {
                                this.cardTable.updateDataByRowId(
                                    code,
                                    res.data.bodys[code],
                                    false,
                                    false,
                                );
                            }

                        }
                    }
                });
            }
        }
        if (res.formulamsg && res.formulamsg instanceof Array && res.formulamsg.length > 0) {
            this.dealFormulamsg(res.formulamsg, tableTypeObj, null, null, index);
        }
        isFunction(callback) && callback(this);
        if (res && typeof this.relationAfterEventCallBack === 'function') {
            this.relationAfterEventCallBack(this.output, key, areaCode, data, res.data, index, rowid); //表体行新旧值
        }
    };
    //发送查询关联项事件
    if (url && data && success) {
        ajax({
            url,
            method: 'post',
            async: false,
            // data: data,
            data: { ...data, controlresult },
            success,
        });
    }
}

// 把激活的规则放在meta上
export function handleMetaRule(meta) {
    if (meta && meta.templetRuleGroups && Array.isArray(meta.templetRuleGroups)) {
        meta.templetRuleGroups.forEach(item => {
            if (item.actived) {
                meta[item.triggeritem] = item.templetrule;
            }
        });
    }
}

// 执行某个区域的字段控制规则
export function runTemplateRuleGroup(data = {}) {
    let { areaCode } = data;
    let meta = this.meta.getMeta();
    // 找到区域内所有的字段控制规则
    let templetRuleArr = [];
    if (!areaCode) {
        templetRuleArr = meta.templetRuleGroups.filter(item => item.actived);
    } else {
        let areaCodeArr = isArray(areaCode) ? areaCode : [areaCode];
        areaCodeArr.forEach(areaCode => {
            let itemRule = meta.templetRuleGroups.filter(item => item.triggeritem.startsWith(`${areaCode}.`) && item.actived);
            templetRuleArr = templetRuleArr.concat(itemRule);
        });
    }
    for (let index = 0; index < templetRuleArr.length; index++) {
        const element = templetRuleArr[index];
        let { triggeritem } = element;
        let dotIndex = triggeritem.indexOf('.');
        let tirggerAreaCode = triggeritem.slice(0, dotIndex);
        let triggerItemCode = triggeritem.slice(dotIndex + 1);
        // 获取组件类型
        let triggerType = meta[tirggerAreaCode]?.moduletype;
        if (triggerType === 'form') {
            // 触发表单字段的控制规则
            let afterData = {
                type: 'form',
                areaCode: tirggerAreaCode,
                key: triggerItemCode,
                triggerMode: 'init',
            };
            handleTemplateRule.call(this, afterData);
        } else if (triggerType === 'table') {
            // 触发表格字段的控制规则，把全表数据传过去，按照复制粘贴批改的逻辑逐行处理
            let rows = [];
            if (this.tableDataSource[tirggerAreaCode]) {
                rows = this.table.getAllTableData(tirggerAreaCode).rows;
            } else if (this.editTableDataSource[tirggerAreaCode]) {
                rows = this.editTable.getVisibleRows(tirggerAreaCode);
            } else if (this.cardTableDataSource[tirggerAreaCode]) {
                rows = this.cardTable.getVisibleRows(tirggerAreaCode);
            }
            let afterData = {
                type: 'table',
                areaCode: tirggerAreaCode,
                key: triggerItemCode,
                rows: rows, // 复制粘贴，批改传进来的是rows
                triggerMode: 'init',
            };
            handleTemplateRule.call(this, afterData);
        }
    }
}

// 获取表格的展开和下拉区域的关联关系
function getGridRelationMap(meta = {}) {
    let { gridrelation = {} } = meta;
    let newGridRelation = {};
    Object.keys(gridrelation).forEach(item => {
        if (gridrelation[item]['destBrowseAreaCode']) {
            newGridRelation[gridrelation[item]['destBrowseAreaCode']] = item;
        }
        if (gridrelation[item]['destEditAreaCode']) {
            newGridRelation[gridrelation[item]['destEditAreaCode']] = item;
        }
    });
    return newGridRelation;
}

// 根据 billtype 取数据
// billType | data格式
// form |
//     { 
//         pageid: "模板编码", 
//         model: { 
//             areacode: '表单区域编码', 
//             areaType: 'form', 
//             rows: [],
//         },
//     }
// grid |
//     { 
//         pageid: "模板编码", 
//         model: { 
//             areacode: '表格区域编码', 
//             areaType: 'table', 
//             rows: [],
//         },
//     }
// card |
//     { 
//         pageid: "模板编码", 
//         head: { 
//             '表单编码': { 
//                 areacode: '表单编码', 
//                 areaType: 'form', 
//                 rows: [] 
//             } 
//         }, 
//         body: { 
//             '表格区域编码': { 
//                 areacode: '表格区域编码', 
//                 areaType: 'table', 
//                 rows: [] 
//             } 
//         } 
//     }
// extcard |
//     {  
//         pageid: "模板编码", 
//         head: { 
//             '表单编码': { 
//                 areacode: '表单编码', 
//                 areaType: 'form', 
//                 rows: [] 
//             } 
//         }, 
//         bodys: { 
//             '表格区域编码1': { 
//                 areacode: '表格区域编码1', 
//                 areaType: 'table', 
//                 rows: [] 
//             }, 
//             '表格区域编码2': { 
//                 areacode: '表格区域编码2', 
//                 areaType: 'table', 
//                 rows: [] 
//             } 
//         } 
//     }
// 显示公式执行完成后执行页面的字段控制规则，这里领域会传进来最终的数据，不需要再去页面取数据
export function runTemplateRuleAfterFormula(ruleData = {}) {
    let meta = this.meta.getMeta();
    // 找到区域内所有的字段控制规则
    let templetRuleArr = meta.templetRuleGroups.filter(item => item.actived && item.triggerevent === 'initialize');
    for (let index = 0; index < templetRuleArr.length; index++) {
        handleTemplateRuleAfterFormula.call(this, { templetrule: templetRuleArr[index].templetrule, ruleData, triggerMode: 'afterFormula' });
        if (ruleData && index === templetRuleArr.length - 1) {
            return ruleData;
        }
    }
}

// 字段控制规则
export function handleTemplateRuleAfterFormula(rule = {}) {
    let {
        templetrule, // 规则数组
        ruleData, // 显示公式用返回的数据，编辑后从页面取数据
        triggerMode = 'afterEdit', // 触发模式，默认值 'afterEdit' 编辑后, 'init' 领域初始化以后调用，'afterFormula' 显示公式之后调用
    } = rule;
    let meta = this.meta.getMeta();
    console.log(meta);
    // 遍历当前字段的规则组
    for (let ruleIndex = 0; ruleIndex < templetrule.length; ruleIndex++) {
        const ruleElement = templetrule[ruleIndex];
        // 判断是否满足当前规则的前置条件
        let { valueResult, ruleAreaType, ruleAreaCode, ruleItemCode, conditionResult } = getCheckTemplateData.call(this, { meta, rulecondition: ruleElement.rulecondition, ruleData, triggerMode });
        // 获取字段控制规则结果的所有组件类型和编码
        let { ruleResultType, ruleResultCode } = getRuleResultType({ controlresult: ruleElement.controlresult, meta });
        // 如果有前置条件
        let tableData = {};
        if (conditionResult.length) {
            let tokenModel = new TokenParseModel(conditionResult);
            tokenModel.initNodeTreeData();
            if (ruleAreaType.has('table') && ruleResultType.has('table')) {
                // 前置条件有表格，控制结果有表格，对表格逐行处理
                // 找一下 tableCode
                let tableCode;
                let resultTableData = [];
                for (const key in valueResult) {
                    if (Object.hasOwnProperty.call(valueResult, key)) {
                        const valueResultElement = valueResult[key];
                        // 找到 valueResult 中 key 值在 ruleAreaCode 里，value值为数组的项
                        // 这里拿到的是全表数据，需要根据每一行的值走前置条件的判断
                        if (ruleAreaCode.has(key) && isArray(valueResultElement)) {
                            tableCode = key;
                            for (let tableIndex = 0; tableIndex < valueResultElement.length; tableIndex++) {
                                // 找到具体一行的数据，根据 ruleItemCode 取到当前行的具体字段的值，重新组成 resultValue
                                const tableRowData = valueResultElement[tableIndex];
                                let newValueResult = {};
                                let ruleItemCodeArr = [...ruleItemCode];
                                for (let itemIndex = 0; itemIndex < ruleItemCodeArr.length; itemIndex++) {
                                    const tableItemCode = ruleItemCodeArr[itemIndex];
                                    newValueResult = { ...valueResult, [key]: { [tableItemCode]: tableRowData.values[tableItemCode]?.value } };
                                }
                                // 按照当前行的值走前置条件，满足所有前置条件返回true 
                                let flag = tokenModel.executeAst(newValueResult, tokenModel.nodeTree)?.tValue;
                                // 把表格中所有满足条件的行拿出来，一起交给后端走设值逻辑
                                // console.log("🚀 ~ file: createPage.js ~ line 2098 ~ Page ~ constructor ~ flag", flag);
                                if (flag) {
                                    resultTableData.push(tableRowData);
                                }
                            }
                        }
                    }
                }
                if (resultTableData.length) {
                    tableData[tableCode] = resultTableData;
                } else {
                    continue;
                }
            } else {
                // 其他情况下表格取值按照当前行数据取值
                let flag = tokenModel.executeAst(valueResult, tokenModel.nodeTree)?.tValue;
                // console.log("🚀 ~ file: createPage.js ~ line 2132 ~ Page ~ constructor ~ flag", flag);
                if (flag) {
                    tableData = null;
                } else {
                    continue;
                }
            }
        } else {
            // 控制结果是表格，控制结果对表格逐行处理
            if (ruleResultType.has('table')) {
                let ruleResultCodeArr = [...ruleResultCode];
                for (let ruleResultIndex = 0; ruleResultIndex < ruleResultCodeArr.length; ruleResultIndex++) {
                    let resultTableData = [];
                    let ruleResultTableCode = ruleResultCodeArr[ruleResultIndex];
                    resultTableData = getCheckTemplateValue.call(this, { triggerMode, ruleData });
                    tableData[ruleResultTableCode] = resultTableData;
                }
            } else {
                tableData = null;
            }
        }
        runTemplateRule.call(this, { meta, controlresult: ruleElement.controlresult, record: tableData ? tableData : null, triggerMode: 'afterFormula' });
    }
}